import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const LG_BREAKPOINT = 1024;
// 1366viewportで400pxスライドを目標 → 1366 / (400 + 20) ≈ 3.25。3.4で視覚的に見切れ感を出す
const SLIDES_PER_VIEW = 3.4;
const SPACE_BETWEEN = 20;
// loopには画面内の表示枚数より1枚多い元スライドが必要
const MIN_LOOP_SLIDES = Math.ceil(SLIDES_PER_VIEW) + 1;
// loop表示で警告が出ないよう、ceil(slidesPerView) × 4 で十分多めに確保
const MIN_SLIDES = Math.ceil(SLIDES_PER_VIEW) * 4;
const STATIC_CLASS = 'pg-home-area-estate-recommend__swiper--static';
const RESIZE_DEBOUNCE = 200;

const areaEstateRecommend = () => {
    const el = document.querySelector('.js-area-estate-recommend-swiper');
    if (!el) return;

    // カード内にサムネイル用の入れ子Swiperがあるため、直下のwrapper／スライドのみを対象にする
    const wrapper = el.querySelector(':scope > .swiper-wrapper');
    if (!wrapper) return;

    const originalSlides = Array.from(wrapper.querySelectorAll(':scope > .swiper-slide'));
    const originalCount = originalSlides.length;
    if (originalCount === 0) return;

    // loop可能な件数に満たない場合はSwiperを初期化せず、中央寄せで並べる
    const canLoop = originalCount >= MIN_LOOP_SLIDES;

    let swiper = null;

    const activate = () => {
        if (!canLoop) {
            el.classList.add(STATIC_CLASS);
            return;
        }
        if (swiper) return;

        // 元スライド数が MIN_SLIDES 未満の場合はクローンして補充
        if (originalCount < MIN_SLIDES) {
            const times = Math.ceil(MIN_SLIDES / originalCount);
            for (let i = 1; i < times; i++) {
                originalSlides.forEach((slide) => {
                    wrapper.appendChild(slide.cloneNode(true));
                });
            }
        }

        swiper = new Swiper(el, {
            modules: [Autoplay],
            loop: true,
            slidesPerView: SLIDES_PER_VIEW,
            spaceBetween: SPACE_BETWEEN,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    };

    const deactivate = () => {
        el.classList.remove(STATIC_CLASS);
        if (!swiper) return;

        swiper.destroy(true, true);
        swiper = null;

        // 補充クローンとloopクローンをまとめて捨て、元のスライド構成に戻す
        wrapper.replaceChildren(...originalSlides);
    };

    // SP は Swiper 不要（通常の縦リストとして表示）
    const sync = () => (window.innerWidth >= LG_BREAKPOINT ? activate() : deactivate());

    sync();

    // 高さのみの変化（モバイルのURLバー伸縮など）では作り直さない
    let lastWidth = window.innerWidth;
    let timer = null;
    window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;

        clearTimeout(timer);
        timer = setTimeout(sync, RESIZE_DEBOUNCE);
    });
};

export default areaEstateRecommend;
